import Button from "@/components/button/Button.tsx";
import {URL_ORIGINAL_WEBSITE} from "@/lib/links.ts";

export const AccountUsageActionBar = () => {
  return (
    <Button as={"a"} variant={"secondary"} href={`${URL_ORIGINAL_WEBSITE}/accounts/account-usage/download`}>
      Download CSV
    </Button>
  );
};
